var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStoryIcon = function SvgStoryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3M15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149M5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442M3 12C3 11.1007 3.13458 10.2154 3.39259 9.37079M5.24582 6.05178C5.3711 5.90953 5.50121 5.77087 5.63604 5.63604C5.75446 5.51762 5.87584 5.40284 6 5.29178",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90325 9.30322C8.35332 8.85329 8.96365 8.60053 9.60005 8.60053C10.2364 8.60053 10.8468 8.85329 11.2968 9.30322L12 10.0058L12.7032 9.30322C12.9246 9.07399 13.1895 8.89116 13.4823 8.76537C13.7751 8.63959 14.09 8.57339 14.4087 8.57062C14.7274 8.56785 15.0434 8.62857 15.3383 8.74925C15.6333 8.86992 15.9013 9.04813 16.1266 9.27347C16.3519 9.49881 16.5301 9.76678 16.6508 10.0617C16.7715 10.3567 16.8322 10.6727 16.8295 10.9914C16.8267 11.3101 16.7605 11.625 16.6347 11.9178C16.5089 12.2106 16.3261 12.4754 16.0968 12.6968L12 16.7942L7.90325 12.6968C7.45332 12.2468 7.20056 11.6364 7.20056 11C7.20056 10.3636 7.45332 9.75328 7.90325 9.30322Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/story-icon.6f2341fb.svg";
export { ForwardRef as ReactComponent };